var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 294,
    viewBox: "0 0 151 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1023 144C47.8023 144 23.5023 159.3 16.0023 171.6V0.599984H0.102344V293.4H16.0023V266.4C23.5023 279 47.8023 294 75.1023 294C116.202 294 150.402 260.1 150.402 219C150.402 177.9 116.202 144 75.1023 144ZM75.1023 278.1C42.1023 278.1 16.0023 252 16.0023 219C16.0023 186 42.1023 159.9 75.1023 159.9C108.402 159.9 134.202 186 134.202 219C134.202 252 108.402 278.1 75.1023 278.1Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerB);
export default __webpack_public_path__ + "static/media/LOWER_B.d707be789f5f58f20c3436b2f357c77b.svg";
export { ForwardRef as ReactComponent };